export default __webpack_public_path__ + "static/media/1_galeria.4617ebc9.webp";